import { Box, useTheme } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import React from 'react'

import UploadStatusListInstance, { UploadStatusListProvider } from '../../../store/uploadstatuslistdialog.store'
import AdmissionExamStoreInstance, { AdmissionExamStoreProvider } from '../../../store/admission-exam.store'
import ApiProviderStoreInstance, { ApiProviderStoreProvider } from '../../../store/apiprovider.store'
import AnalyticsStoreInstance, { AnalyticsStoreProvider } from '../../../store/analytics.store'
import DownloadStatusListDialog from '../../study-material/DownloadStatusListDialog'
import UploadsStatusList from '../../online-course/UploadsStatusList'
import { useLayoutContext } from '../../../../shared/contexts/layout.context'
import aliveLogoImg from '../../../../shared/assets/alivelogo.png'
import SideDrawer from './AdminSideDrawer'
import Navbar from './AdminNavbar'


const Layout = ( { navHeadText } ) => {

    const { navHeight, setMenuState, minSidebarCollapseWidth } = useLayoutContext()

    const { palette, theme } = useTheme()

    const handleResizeOrLoad = () => window.innerWidth < minSidebarCollapseWidth ? setMenuState( false ) : setMenuState( true )

    useEffect( () => {
        window.addEventListener( 'resize', handleResizeOrLoad )
        window.addEventListener( 'load', handleResizeOrLoad )
        return () => {
            window.removeEventListener( 'resize', handleResizeOrLoad )
            window.removeEventListener( 'resize', handleResizeOrLoad )
        }
    } )

    return (
        <AnalyticsStoreProvider store={AnalyticsStoreInstance}>
            <ApiProviderStoreProvider store={ApiProviderStoreInstance}>
                <UploadStatusListProvider store={UploadStatusListInstance}>
                    <AdmissionExamStoreProvider store={AdmissionExamStoreInstance}>
                        <Box
                            sx={{
                                flexDirection: { sm: "row", xs: "column-reverse" },
                                bgcolor: palette.layoutBackground,
                                display: "flex",
                                height: "100%",
                                overflow: "auto"
                            }}>
                            <SideDrawer closeSideMenu={() => setMenuState( false )} />
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    minWidth: "0",
                                    position: "relative",
                                    overflow: "auto"
                                }}>
                                <Navbar navHeadText={navHeadText} closeSideMenu={() => setMenuState( false )} openSideMenu={() => setMenuState( true )} />
                                <Box
                                    id="page-content"
                                    className={theme}
                                    sx={{
                                        bgcolor: palette.background.default,
                                        overflow: "auto",
                                        borderRadius: { sm: "10px 0 0 0", xs: "0" },
                                        flexGrow: 1,
                                        display: "flex",
                                        minWidth: "0",
                                        position: "relative"
                                    }}>
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            zIndex: 100,
                                            inset: 0,
                                            opacity: "0.1",
                                            pointerEvents: "none"
                                        }}>
                                        <Box
                                            component="img"
                                            src={aliveLogoImg}
                                            sx={{
                                                width: "30%",
                                                opacity: "0.4"
                                            }} />
                                    </Box>
                                    <Outlet />
                                </Box>
                            </Box>
                            <DownloadStatusListDialog />
                            <UploadsStatusList />
                        </Box>
                    </AdmissionExamStoreProvider>
                </UploadStatusListProvider>
            </ApiProviderStoreProvider>
        </AnalyticsStoreProvider>
    );
}

export default Layout
